// @ts-nocheck
import Card from '@material-ui/core/Card';
import { ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import moment from 'moment';
import React from 'react';
import PowerStatusBadge from './PowerStatusBadge.jsx';
import { renderPcuEventType } from './powerControlUnitEventFormatters.js';

class PowerControlUnitEventRow extends React.Component {
  formatTimestamp(timestamp) {
    if (!timestamp) {
      return '-';
    }
    return moment(timestamp).format('LLL');
  }

  render() {
    const { event } = this.props;
    if (!event) {
      return null;
    }
    const outcomeColor = event.outcome === 'SUCCESS' ? '#4caf50' : '#f44336';

    return (
      <Card
        elevation={1}
        style={{
          marginBottom: 10,
          padding: '14px 20px',
        }}
      >
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 12,
          alignItems: 'flex-start',
        }}
        >
          <div style={{ flex: '1 1 180px', minWidth: 160 }}>
            <h6 style={{ margin: 0, marginBottom: 4, fontSize: 12, color: '#888', fontWeight: 600 }}>
              {L20NContext.getSync('timestamp')}
            </h6>
            <h5 style={{ margin: 0, color: '#3f3f3f', fontSize: 15 }}>{this.formatTimestamp(event.timestamp)}</h5>
          </div>
          <div style={{ flex: '1 1 140px', minWidth: 120 }}>
            <h6 style={{ margin: 0, marginBottom: 4, fontSize: 12, color: '#888', fontWeight: 600 }}>
              {L20NContext.getSync('eventType')}
            </h6>
            <h5 style={{ margin: 0, color: '#3f3f3f', fontSize: 15 }}>{renderPcuEventType(event.eventType)}</h5>
          </div>
          <div style={{ flex: '1 1 120px', minWidth: 100 }}>
            <h6 style={{ margin: 0, marginBottom: 4, fontSize: 12, color: '#888', fontWeight: 600 }}>
              {L20NContext.getSync('pcuPowerState')}
            </h6>
            <h5 style={{ margin: 0, fontSize: 15 }}>
              {event.state ? <PowerStatusBadge state={event.state} /> : '-'}
            </h5>
          </div>
          <div style={{ flex: '1 1 100px', minWidth: 80 }}>
            <h6 style={{ margin: 0, marginBottom: 4, fontSize: 12, color: '#888', fontWeight: 600 }}>
              {L20NContext.getSync('outcome')}
            </h6>
            <h5 style={{ margin: 0, color: outcomeColor, fontWeight: 600, fontSize: 15 }}>
              {event.outcome || '-'}
            </h5>
          </div>
        </div>
      </Card>
    );
  }
}

export default PowerControlUnitEventRow;
